import { IProviders, IState, Statuses, Spaces, ISpace } from '@/pages/organizations/card/spaces/types';
import { Module, Mutation, Action, VuexModule } from 'vuex-module-decorators';

const storeModule = ({ $api }: IProviders) => {
  @Module({
    namespaced: true,
    stateFactory: true,
  })
  class Space extends VuexModule<IState, any> {
    status: Statuses = Statuses.READY;
    spaces: Spaces = [];
    count: number = 0;
    page: number = 0;
    limit: number = 0;
    @Action
    async init({ params, query }: any) {
      const { commit } = this.context;
      // console.log(query);
      commit('setState', Statuses.WAITING);
      try {
        const { data: { data, filtered, limit, page } } = await $api.get(`inventory-object/get/${params.partnerId}`, {
          params: query
        })
        commit('updateCount', Number(filtered || 0));
        commit('updatePage', Number(page || 1));
        commit('updateLimit', Number(limit || 7));
        commit('setSpaces', data as Spaces);
        commit('setState', Statuses.READY);
      } catch (err) {
        commit('setState', Statuses.ERROR);
      }
    }

    @Mutation
    updateCount(value: number) {
      this.count = value;
    }
  
    @Mutation
    updatePage(value: number) {
      this.page = value;
    }
  
    @Mutation
    updateLimit(value: number) {
      this.limit = value;
    }
    
    @Mutation
    setState(payload: Statuses) {
      this.status = payload;
    }
    
    @Mutation
    setSpaces(payload: Spaces) {
      this.spaces = payload;
    }
  
    get getSpaces() {
      return this.spaces;
    }
  }
  
  return Space;
}

export default storeModule;



// WEBPACK FOOTER //
// ./src/pages/organizations/card/spaces/store.ts